import { observer } from "mobx-react";
import { useEffect } from "react";
import { RemoveSignatureFromArticlesOfAssociationForm } from "./removeSignatureFromArticlesOfAssociationDomain";
import {
  ArticleSelectorQuestion,
  LocalizedMarkdownQuestion,
  YesNoQuestion,
} from "@/dbot/common/commonComponents";
import { VBox } from "@/components-v2/Box";

import { useTranslation } from "@/stores/RootStoreContext";

export const RemoveSignatureFromArticlesOfAssociationView = observer(
  function RemoveSignatureFromArticlesOfAssociationViewView({
    form,
  }: {
    form: RemoveSignatureFromArticlesOfAssociationForm;
  }) {
    const { t } = useTranslation();

    useEffect(() => {
      form.init();
    }, [form]);

    return (
      <VBox gap={"md"}>
        <ArticleSelectorQuestion
          question={t("decisions.signature.remove")}
          model={form.paragraphNumber}
          onChange={form.setParagraphNumber}
          isLocked={form.isProjectLocked}
        />

        {form.isValidSignatureParagraph && (
          <YesNoQuestion
            question={t("decisions.signature.paragraphRegulatesOtherMatters", {
              paragraph: form.paragraphNumber.selected,
            })}
            field={form.paragraphContainsMultipleClauses}
            isLocked={form.isProjectLocked}
          />
        )}
        {form.paragraphContainsMultipleClauses.value && (
          <LocalizedMarkdownQuestion
            textModels={form.paragraphTexts}
            name={"article-text"}
            question={t("decisions.signature.removeParagraphRegulatesOtherMatters", {
              paragraph: form.paragraphNumber.selected,
            })}
            isLocked={form.isProjectLocked}
          />
        )}
      </VBox>
    );
  },
);
